"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
var useLocale_1 = require("./useLocale");
Object.defineProperty(exports, "useLocale", { enumerable: true, get: function () { return useLocale_1.useLocale; } });
